<template lang="pug">
b-row
    b-col.d-none.d-lg-block(lg="3")
        Filters.my-3.py-3.filters-desktop(:filters="filtersData" v-if="!isMobile")
    b-col.my-3.px-0.p-md-3(md="12" lg="9")
        FAQ
        transition-group(
            name="transition_list",
            tag="section",
            v-if="companies.length"
        )
            Card(
                v-for="(company, idx) in paginatedCompanies",
                :key="`company_${idx}`",
                :url="{ name: 'company', params: { companyId: company.id } }",
                :title="company.title",
                :subtitle="company.details.location",
                :subtitle2="companyConnectionsText(company)",
                :image="company.image",
                :text="company.details.description",
                :tags="[[...company.regions, ...company.interactions], [...company.branches]]",
                :showMore="true"
            )

            .mt-4.text-center(
                v-if="paginatedCompanies.length < companies.length",
                key="show-more-button"
            )
                b-btn.button(@click="currentPage += 1") Показать ещё

        section.card.mt-3(v-else)
            p.mb-0.text-center По вашему запросу ничего не найдено.
                br
                | Попробуйте изменить условия поиска.
</template>

<script>
import Card from "@/components/CardComponent.vue";
import Filters from "@/components/Filters.vue";
import FAQ from "@/components/FAQ.vue";

export default {
    name: "Home",
    components: { Card, FAQ, Filters },
    data: () => ({
        itemsPerPage: 10,
        currentPage: 0,
    }),
    computed: {
        searchQuery() {
            return this.$store.state.searchQuery;
        },
        filterQuery() {
            return this.$store.state.filterQuery;
        },
        filtersData() {
            return this.$store.state.filters;
        },
        isMobile() {
            return this.$store.state.isMobile;
        },
        companies() {
            return this.searchQuery
                ? this.$store.getters.companiesFilterByQuery(this.searchQuery)
                : this.$store.getters.companiesFilterByTags(this.filterQuery);
        },
        paginatedCompanies() {
            return this.companies.slice(0, (this.currentPage + 1) * this.itemsPerPage);
        },
    },
    methods: {
        companyConnectionsText(company) {
            if (company.offers && company.offers.length) {
                const n = company.offers.length;
                return `${n} connection${n > 1 ? "s" : ""}`;
            }
            return "";
        },
    },
    watch: {
        searchQuery() {
            this.currentPage = 0;
            window.scrollTo({ top: 0, behavior: "instant" });
        },
    },
};
</script>

<style lang="scss">
.transition_list-enter-active,
.transition_list-leave-active {
    transition: all 0.1s !important;
}
.transition_list-enter,
.transition_list-leave-to {
    opacity: 0 !important;
    transform: translateX(30px) !important;
}
</style>
